import React from "react";
import PropTypes from "prop-types";
import Button from "@/components/Button";
import { useNativeSharingModal } from "@/hooks/nativeSharing";
import { MobileShareLink } from "@/icons";
import styles from "./mobileNativeShare.module.scss"

const MobileNativeShare = ({ url, title, onError }) => {
  const { openNativeSharingModal } = useNativeSharingModal({ onError });

  const handleMobileNativeShare = () => {
    openNativeSharingModal({ url, title });
  };

  return (
    <>
      <Button className={styles.mobileNativeShareButton} onClick={handleMobileNativeShare}>
        <MobileShareLink />
        <span>Share</span>
      </Button>
    </>
  )
}

export default MobileNativeShare;

MobileNativeShare.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  onError: PropTypes.func
}
